import { isValid5DigitZip, isValid9DigitZip, isValidCanadianZip, isValidAddressLine, validateAddress } from '../../utils/validation';
import Constants, { COUNTRY_CODE_CANADA, COUNTRY_CODE_MEXICO, COUNTRY_CODE_UNITED_STATES, DEFAULT_ID } from '../../utils/Constants';

export const localValidate = async (formState) => {
  let errors = {};

  let addressError = false;
  //Address Type
  if (formState.addressTypeId < 0) {
    addressError = true;
    errors.addressTypeId = 'Address Type is required';
  }

  //Country
  if (formState.country === Constants.DEFAULT_ID || formState.country === '') {
    addressError = true;
    errors.country = 'Country is required';
  }

  //Address Line 1
  if (formState.address1.trim() === '') {
    addressError = true;
    errors.address1 = 'Address Line 1 is required';
  }
  else if (!isValidAddressLine(formState.address1.trim())) {
    addressError = true;
    errors.address1 = 'Address Line 1 cannot exceed 100 characters. Letters, numbers, number signs, spaces, periods, dashes, slashes, and apostrophes are allowed.';
  }

  //Address Line 2
  if (formState.address2.trim() !== '') {
    if (!isValidAddressLine(formState.address2.trim())) {
      addressError = true;
      errors.address2 = 'Address Line 2 cannot exceed 100 characters. Letters, numbers, number signs, spaces, periods, dashes, slashes, and apostrophes are allowed.';
    }
  }

  //City
  if (formState.city.trim() === '') {
    addressError = true;
    errors.city = 'City is required';
  }
  else if (!isValidAddressLine(formState.city.trim())) {
    addressError = true;
    errors.city = 'City cannot exceed 100 characters. Letters, numbers, number signs, spaces, periods, dashes, slashes, and apostrophes are allowed.';
  }

  //State
  if (formState.country === COUNTRY_CODE_UNITED_STATES || formState.country === COUNTRY_CODE_MEXICO || formState.country === COUNTRY_CODE_CANADA) {
    if (formState.state !== '') {
      if (formState.stateCode === DEFAULT_ID || formState.stateCode === '') {
        addressError = true;
        errors.state = 'Must be a valid state';
      }
    } else {
      addressError = true;
      errors.state = 'State is required';
    }
  }

  //Zip Code
  if (formState.postalCode.trim() === '') {
    addressError = true;
    errors.postalCode = 'Zip Code is required';
  } else if ((formState.country === COUNTRY_CODE_UNITED_STATES) && !isValid5DigitZip(formState.postalCode.trim()) && !isValid9DigitZip(formState.postalCode.trim())) {
    addressError = true;
    errors.postalCode = 'USA Zip Code must be 5 digits, or 9 digits in XXXXX-XXXX format';
  } else if ((formState.country === COUNTRY_CODE_CANADA) && !isValidCanadianZip(formState.postalCode.trim())) {
    addressError = true;
    errors.postalCode = 'Canadian Zip Code must be valid and in A1A 1A1 format';
  } else if ((formState.country === COUNTRY_CODE_MEXICO) && !isValid5DigitZip(formState.postalCode.trim())) {
    addressError = true;
    errors.postalCode = 'Mexican Zip Code must be 5 digits';
  }

  if (formState.country === COUNTRY_CODE_UNITED_STATES || formState.country === COUNTRY_CODE_MEXICO || formState.country === COUNTRY_CODE_CANADA) {
    if (addressError === false
      && formState.showedAddressSuggestion === false) {
      formState.validatedAddress = await validateAddress(formState.address1?.trim(), formState.address2?.trim(), formState.city?.trim(), formState.stateCode, formState.postalCode?.trim());
      if (formState.validatedAddress.isValid === true
        && (
          formState.address1?.trim() !== formState.validatedAddress.address1?.trim()
          || formState.address2?.trim() !== formState.validatedAddress.address2?.trim()
          || formState.city?.trim() !== formState.validatedAddress.city?.trim()
          || formState.stateCode !== formState.validatedAddress.stateCode
          || formState.postalCode?.trim() !== formState.validatedAddress.postalCode?.trim()
        )
      ) {
        if (formState.address1?.trim() !== formState.validatedAddress.address1?.trim()) {
          errors.address1 = 'See Address Suggestion';
        }
        if (formState.address2?.trim() !== formState.validatedAddress.address2?.trim()) {
          errors.address2 = 'See Address Suggestion';
        }
        if (formState.city?.trim() !== formState.validatedAddress.city?.trim()) {
          errors.city = 'See Address Suggestion';
        }
        if (formState.stateCode !== formState.validatedAddress.stateCode) {
          errors.stateCode = 'See Address Suggestion';
        }
        if (formState.postalCode?.trim() !== formState.validatedAddress.postalCode?.trim()) {
          errors.postalCode = 'See Address Suggestion';
        }
      }
    }
  }

  return errors;
};

const MemberContactAddressDetailValidation = async (formState) => {
  let errors = await localValidate(formState);

  return errors ? errors : {};
};

export default MemberContactAddressDetailValidation;